<mat-tab-group [@.disabled]="true">
    <mat-tab>
      <ng-template mat-tab-label>
        <!-- <span class="asana">Mach</span> -->
        <!-- <img class="h-4" src="assets/math/Mach.png"> -->
        <!-- <p class="source_serif">Mach</p> -->
        <img src="assets/math/Mach.svg" alt="">
      </ng-template>
      <ng-template matTabContent>
        <div class="content-center">
          <!-- <p>a</p> -->
          <app-if-mach></app-if-mach>
        </div>
      </ng-template>
    </mat-tab>
  
    <mat-tab>
      <ng-template mat-tab-label>
        <!-- <p class="source_serif" style="font-style: italic">p / p<sub>t</sub></p> -->
        <!-- <img class="object-contain h-6" src="assets/math/p_pt.svg"> -->
        <img src="assets/math/ppt.svg" alt="">
      </ng-template>
      <ng-template matTabContent>
        <div>
          <app-if-ppt></app-if-ppt>
          <!-- <if-ppt></if-ppt> -->
        </div>
      </ng-template>
    </mat-tab>
  
  
    <mat-tab>
      <ng-template mat-tab-label>
        <!-- <ttt></ttt> -->
        <!-- <p class="source_serif"><i>T / T<sub>t</sub></i></p> -->
        <!-- <span class="mathitalic">T &frasl; T<sub>t</sub></span> -->
        <img src="assets/math/ttt.svg" alt="">

      </ng-template>
      <ng-template matTabContent>
        <app-if-ttt></app-if-ttt>
        <!-- <if-ttt></if-ttt> -->
      </ng-template>
    </mat-tab>
  
    <!-- A / A* -->
    <mat-tab>
      <ng-template mat-tab-label>
          <!-- <aas></aas> -->
          <!-- <p class="mathitalic"> A &frasl; A* </p> -->
          <!-- <img class="object-contain h-6" src="assets/math/aas.svg"> -->
          <!-- <p class="source_serif"><i>A / A<sup>*</sup></i></p> -->
          <img src="assets/math/aas2.svg" alt="">

      </ng-template>
      <ng-template matTabContent>
        <app-if-aas></app-if-aas>
        <!-- <if-aas></if-aas> -->
      </ng-template>
    </mat-tab>
  
    <!-- pA / ptA* -->
    <mat-tab>
      <ng-template mat-tab-label>
        <!-- <paptas></paptas> -->

        <!-- <p class="mathitalic"> -->
          <!-- pA &frasl; p<sub>t</sub> A* -->

          <!-- <p class="source_serif"><i>pA / p<sub>t</sub>A<sup>*</sup></i></p> -->

          <!-- <img src="" alt=""> -->

          <!-- <img class="object-contain h-6" src="assets/math/paptas2.svg"> -->
          <img class="" src="assets/math/paptas2.svg">


        <!-- </p> -->
      </ng-template>
      <div>
        <ng-template matTabContent>
  
          <app-if-paptas></app-if-paptas>
          <!-- <if-paptas></if-paptas> -->
        </ng-template>
  
      </div>
    </mat-tab>
  
    <!-- Mach angle -->
    <mat-tab>
      <ng-template mat-tab-label>

        <img src="assets/math/mach_ang_b.svg" alt="">

        <!-- <ma></ma> -->
      

      </ng-template>
      <div>
  
        <ng-template matTabContent>
  
          <app-if-machang></app-if-machang>
          <!-- <if-ma></if-ma> -->
  
        </ng-template>
  
      </div>
    </mat-tab>
  
  </mat-tab-group>